import { Outlet } from "react-router-dom";
import Header from "./Header";
import ContactStrip from "./ContactStrip";
import StickyContactBar from "./StickyContactBar";
import Footer from "./Footer";
import useLenis from "@/lib/useLenis";

export default function Layout() {
  useLenis();
  return (
    <div className="min-h-screen bg-[#F5F3EF] text-[#111111] antialiased selection:bg-[#111111] selection:text-[#F5F3EF] relative">
      {/* Grain overlay */}
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[60] opacity-[0.08] mix-blend-multiply"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='240' height='240'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.55'/></svg>\")",
        }}
      />
      <Header />
      <main className="pt-[112px] md:pt-[124px]">
        <ContactStrip />
        <Outlet />
      </main>
      <Footer />
      <StickyContactBar />
    </div>
  );
}
